import { Component, Input } from '@angular/core';
import type { ProductInfo } from '@legacy/common-ui-models';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { ScIconPipe } from '@core/jss-utils';

@Component({
  selector: 'wl-generic-offer-info[productInfo]',
  templateUrl: './generic-offer-info.component.html',
  styleUrls: [
    './generic-offer-info.component.ed.scss',
    './generic-offer-info.component.essent.scss',
  ],
  standalone: true,
  imports: [FaIconComponent, ScIconPipe],
})
export class GenericOfferInfoComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() marginTop = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() horizontalMargins = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() productInfo: ProductInfo[] = [];
}
